module.exports = __webpack_public_path__ + "static/media/DryCleaning.7f926cf9.jpg";